import React from 'react';
import { Skeleton } from '@mui/material';
import {
  ChartAreaContainer,
  ChartLinesContainer,
  ChartSkeletonContainer,
  GridLinesContainer,
  XAxisContainer,
  YAxisContainer,
} from '../../styled';

export const ChartAreaSkeleton: React.FC = () => (
  <ChartSkeletonContainer>
    <ChartAreaContainer>
      <GridLinesContainer>
        {/* Horizontal grid lines */}
        {Array.from({ length: 5 }).map((_, index) => (
          <Skeleton
            key={`grid-${index}`}
            variant="rectangular"
            width="100%"
            height={1}
            sx={{ opacity: 0.3 }}
          />
        ))}
      </GridLinesContainer>

      <ChartLinesContainer>
        {/* Chart line skeleton */}
        <Skeleton
          variant="rectangular"
          width="90%"
          height={2}
          sx={{ alignSelf: 'center', borderRadius: 1 }}
        />
      </ChartLinesContainer>
    </ChartAreaContainer>

    {/* Y-axis labels */}
    <YAxisContainer>
      {Array.from({ length: 5 }).map((_, index) => (
        <Skeleton
          key={`y-axis-${index}`}
          variant="text"
          width={40}
          height={16}
        />
      ))}
    </YAxisContainer>

    {/* X-axis labels */}
    <XAxisContainer>
      {Array.from({ length: 4 }).map((_, index) => (
        <Skeleton
          key={`x-axis-${index}`}
          variant="text"
          width={60}
          height={16}
        />
      ))}
    </XAxisContainer>
  </ChartSkeletonContainer>
);
